module.exports = __webpack_public_path__ + "public/SiteIcons/callLogo.svg?286c5771";